import { Center, Loader } from '@mantine/core';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Permission } from '../../server/src/models/User';
import { UserRole } from '../types/auth.types';
import { useAuthContext } from './AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: Permission[];
}

export function ProtectedRoute({ children, requiredPermissions = [] }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="xl" />
      </Center>
    );
  }

  // Check permissions if needed
  if (requiredPermissions.length > 0) {
    // Admin has all permissions
    if (user?.role === UserRole.ADMIN) {
      return <>{children}</>;
    }

    // Check if user has required permissions
    const userPermissions = user?.userPermissions?.map(p => p.permission) || [];
    const hasPermission = requiredPermissions.every(p => userPermissions.includes(p));
    
    if (!hasPermission) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
} 